import {
  BULK_UPDATE_ENTITY_RULES,
  BULK_UPDATE_REQUIRED_COLUMNS,
  IBulkUpdateEntityRule,
  TBulkUpdateEntity,
} from './bulkUpdateValidation';

const SAMPLE_BATCH_NUMBERS = ['0000075534', '0000075535'];
const SAMPLE_VINS = ['7UUG1GHJ0TA011306', '7UUG1GHJ0TA011307'];

const COLUMN_WIDTHS = [18, 22, 22, 26];

const headerCell = (value: string) => ({ value, type: String, fontWeight: 'bold' as const });

const textCell = (value: string) => ({ value, type: String });

// '@' forces Excel's "Text" type so leading zeros are not stripped when the sheet is edited.
const literalTextCell = (value: string) => ({ value, type: String, format: '@' });

const buildSampleRows = (rule: IBulkUpdateEntityRule) =>
  rule.sampleValues.map((sampleValue, index) => [
    literalTextCell(SAMPLE_BATCH_NUMBERS[index] ?? SAMPLE_BATCH_NUMBERS[0]),
    literalTextCell(SAMPLE_VINS[index] ?? SAMPLE_VINS[0]),
    textCell(sampleValue),
    textCell(rule.entity),
  ]);

export const getBulkUpdateTemplateFileName = (entity: TBulkUpdateEntity): string =>
  `bulk-update-${entity.toLowerCase().replace(/\s+/g, '-')}-template.xlsx`;

export const downloadBulkUpdateTemplate = async (entity: TBulkUpdateEntity): Promise<void> => {
  const rule = BULK_UPDATE_ENTITY_RULES.find((entityRule) => entityRule.entity === entity);
  if (!rule) {
    throw new Error(`No template is available for entity "${entity}".`);
  }

  const { default: writeXlsxFile } = await import('write-excel-file');
  const rows = [BULK_UPDATE_REQUIRED_COLUMNS.map(headerCell), ...buildSampleRows(rule)];

  await writeXlsxFile(rows as any, {
    columns: COLUMN_WIDTHS.map((width) => ({ width })),
    fileName: getBulkUpdateTemplateFileName(entity),
  });
};
